import {
    Button,
    Card,
    Col, Flex,
    Form,
    Image,
    Input,
    List,
    Result,
    Row,
    Spin,
    Typography,
    Divider
} from "antd";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {toast} from "react-toastify";
// @ts-ignore
import Logo from '../../../assets/images/logo-green-main.png';
import {SurveyOptions} from "./SurveyOptions";
import {useForm} from "antd/es/form/Form";

export const TakeSurvey = ({match}) => {
    const [id] = useState(match ? match.params.id : null);
    const [surveyData, setSurveyData] = useState(null);
    const [responseData, setResponseData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [form] = useForm();
    const [responseId, setResponseId] = useState(match.params.responseId);

    const isPreview = !!(match && match.params && match.params.isAdmin);

    useEffect(() => {
        if (id) {
            setLoading(true);
            const url = isPreview ? `/api/v1/surveys/${id}/preview?isResponse=${responseId}` : `/api/v1/public/survey/${id}`;
            axios.get(url)
                .then((result) => {
                    setSurveyData(result.data.survey);
                    setResponseData(result.data.surveyResponse);
                    setIsCompleted(result.data.isCompleted)
                }).catch((error) => toast.error(error))
                .finally(() => setLoading(false))
        }
    }, [id]);

    const updateQuestion = (item: any, value: any) => {
        setResponseData({
            ...responseData,
            data: responseData.data.map((resp: any) => resp.order === item ? {
                ...resp,
                value
            } : resp)
        });
    }

    const updateGridQuestion = (item: any, rowOrder: any, value: any) => {
        setResponseData({
            ...responseData,
            data: responseData.data.map((resp: any) => resp.order === item ? {
                ...resp,
                rows: resp.rows.map((row: any) => row.order === rowOrder ? {
                    ...row,
                    value
                } : row)
            } : resp)
        })
    }

    const updateCheckBox = (item: any, itemId: any, checked: any) => {
        setResponseData({
            ...responseData,
            data: responseData.data.map((resp: any) => resp.order === item ? {
                ...resp,
                // @ts-ignore
                value: checked ? [...new Set([...resp.value || [], itemId])] : (resp.value || []).filter((a: any) => a !== itemId)
            } : resp)
        })
    }

    const handleSubmit = (shouldComplete: boolean = false) => {
        if (isPreview) {
            toast.info('Preview mode: responses will not be saved.');
            return;
        }
        setLoading(true);
        form.validateFields().then((vals) => {
            axios.post(`/api/v1/public/survey/${id}`, {data: responseData.data, completed: shouldComplete})
                .then((result) => {
                    toast.success('Survey results saved');
                    setResponseData({
                        ...responseData,
                        completed: result.data.completed,
                        started: true
                    });
                    setIsCompleted(result.data.isCompleted)
                }).catch((error) => toast.error(error))
                .finally(() => setLoading(false));
        }).catch((error) => toast.error(error))
            .finally(() => setLoading(false))
    }

    return (
        <Col xs={24} className={'mt-4'}>
            {!match.params.isAdmin && <Image className={'mb-4 center'} src={Logo} preview={false} width={150}/>}
            <Spin spinning={loading}>
                {!surveyData && !loading &&
                    <Card>
                        <Result
                            status={'error'}
                            title={'No survey found.'}
                        />
                    </Card>
                }
                {
                    responseData && !responseId &&
                    <Form
                        form={form}
                        onFinish={() => handleSubmit()}
                        onFinishFailed={(errorInfo) => {
                            const first = errorInfo?.errorFields && errorInfo.errorFields[0];
                            if (first) {
                                try {
                                    form.scrollToField(first.name, {behavior: 'smooth', block: 'center'});
                                } catch (e) {
                                    // no-op
                                }
                            }
                            toast.error('Please answer all required questions before saving. We scrolled to the first one that needs your attention.', {
                                autoClose: 8000,
                            });
                        }}
                        scrollToFirstError={{behavior: 'smooth'}}
                        layout={'vertical'}
                        style={{margin: '24px'}}
                    >
                        <Card styles={{
                            actions: {
                                padding: '8px'
                            }
                        }}
                              title={isCompleted ?
                                  <Button disabled={isPreview || !isCompleted || responseData.completed}
                                          block
                                          style={{width: '100%'}}
                                          type={isCompleted ? 'primary' : 'default'}
                                          onClick={() => handleSubmit(true)}>Submit</Button> : null}
                              loading={loading}
                              actions={[<Flex gap={'small'} justify={'space-evenly'} align={'flex-start'}><Form.Item
                                  key={'submit'} className={'m-0 p-0'} style={{width: '100%'}}><Button block={true}
                                                                                                       htmlType={'submit'}
                                                                                                       disabled={isPreview || responseData.completed || responseData.expired}
                                                                                                       type={isCompleted ? 'default' : 'primary'}>Save</Button></Form.Item>
                                  <Button disabled={isPreview || !isCompleted || responseData.completed}
                                          block
                                          type={isCompleted ? 'primary' : 'default'}
                                          onClick={() => handleSubmit(true)}>Submit</Button></Flex>
                              ]}
                        >
                            {isPreview && (
                                <Result
                                    status={'info'}
                                    title={'Preview mode'}
                                    subTitle={'You are previewing this survey. Responses will not be saved.'}
                                />
                            )}
                            <Card.Meta
                                title={surveyData.name}
                                description={surveyData.description}
                                className={'mb-2'}
                            />
                            {responseData.expired && !match.params.isAdmin &&
                                <Result
                                    status={'warning'}
                                    title={'This survey has expired. Thank you for trying though!'}
                                />
                            }
                            {responseData.completed && !match.params.isAdmin &&
                                <Result
                                    status={'success'}
                                    title={'Thank you for your response, the survey has been submitted!'}
                                />
                            }
                            <Col xs={24}>
                                {(() => {
                                    const getChildren = (parentOrder: any) => (responseData.data || []).filter((q: any) => q.dependentQuestion === parentOrder).sort((a: any, b: any) => a.order - b.order);
                                    const shouldShow = (item: any) => {
                                        if (!item.dependentQuestion) return true;
                                        const parent = (responseData.data || []).find((it2: any) => it2.order === item.dependentQuestion);
                                        if (!parent) return false;
                                        const val = parent.value;
                                        if (Array.isArray(val)) {
                                            return val.includes(item.dependentResponse);
                                        }
                                        return val === item.dependentResponse;
                                    };
                                    const renderItemRecursive = (item: any, isChild: boolean = false) => (
                                        <React.Fragment key={`resp-${item.order}`}>
                                            {shouldShow(item) && (
                                                <Row className={'mb-2'}>
                                                    <Form.Item hidden={true} name={[item.order]}
                                                               initialValue={item}><Input/></Form.Item>
                                                    <Col xs={isChild ? 23 : 24} offset={isChild ? 1 : 0}
                                                         className={isChild ? 'mt-3' : ''}>
                                                        <SurveyOptions
                                                            key={item.order}
                                                            item={item}
                                                            updateGridQuestion={updateGridQuestion}
                                                            responseData={responseData}
                                                            updateCheckBox={updateCheckBox}
                                                            updateQuestion={updateQuestion}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                            {shouldShow(item) && getChildren(item.order).map((child: any) => renderItemRecursive(child, true))}
                                        </React.Fragment>
                                    );
                                    return (responseData.data || [])
                                        .filter((q: any) => !q.dependentQuestion)
                                        .sort((a: any, b: any) => a.order - b.order)
                                        .map((item: any) => renderItemRecursive(item, false));
                                })()}
                            </Col>
                        </Card>
                    </Form>
                }
                {responseData && match.params.isAdmin && responseId && (
                    <Card loading={loading} style={{ margin: '24px' }}>
                        <Card.Meta
                            title={surveyData?.name}
                            description={surveyData?.description}
                            className={'mb-2'}
                        />
                        <Divider />
                        <Col xs={24}>
                            {(() => {
                                const getChildren = (parentOrder: any) => (responseData.data || [])
                                    .filter((q: any) => q.dependentQuestion === parentOrder)
                                    .sort((a: any, b: any) => a.order - b.order);
                                const shouldShow = (item: any) => {
                                    if (!item.dependentQuestion) return true;
                                    const parent = (responseData.data || []).find((it2: any) => it2.order === item.dependentQuestion);
                                    if (!parent) return false;
                                    const val = parent.value;
                                    if (Array.isArray(val)) {
                                        return val.includes(item.dependentResponse);
                                    }
                                    return val === item.dependentResponse;
                                };
                                const renderAnswer = (item: any) => {
                                    const empty = <Typography.Text type={'secondary'}>—</Typography.Text>;
                                    switch (item.type) {
                                        case 'input':
                                        case 'calendar':
                                            return item.value ? <Typography.Text>{item.value}</Typography.Text> : empty;
                                        case 'select':
                                        case 'radio': {
                                            const opt = (item.options || []).find((o: any) => o.order === item.value);
                                            return opt ? <Typography.Text>{opt.description}</Typography.Text> : empty;
                                        }
                                        case 'checkbox': {
                                            const values: any[] = item.value || [];
                                            if (!values.length) return empty;
                                            const labels = (item.options || [])
                                                .filter((o: any) => values.includes(o.order))
                                                .map((o: any) => o.description);
                                            return labels.length ? <Typography.Text>{labels.join(', ')}</Typography.Text> : empty;
                                        }
                                        case 'grid': {
                                            const cols = item.columns || [];
                                            const rows = item.rows || [];
                                            if (!rows.length) return empty;
                                            return (
                                                <Col xs={24}>
                                                    {rows.map((r: any) => {
                                                        const col = cols.find((c: any) => c.order === r.value);
                                                        return (
                                                            <Row key={`row-${item.order}-${r.order}`} className={'mb-1'}>
                                                                <Col xs={12}><Typography.Text strong>{r.description}</Typography.Text></Col>
                                                                <Col xs={12}><Typography.Text>{col ? col.description : '—'}</Typography.Text></Col>
                                                            </Row>
                                                        );
                                                    })}
                                                </Col>
                                            );
                                        }
                                        default:
                                            return item.value ? <Typography.Text>{String(item.value)}</Typography.Text> : empty;
                                    }
                                };
                                const renderItemRecursive = (item: any, isChild: boolean = false) => (
                                    <React.Fragment key={`resp-${item.order}`}>
                                        {shouldShow(item) && (
                                            <Row className={'mb-3'}>
                                                <Col xs={isChild ? 23 : 24} offset={isChild ? 1 : 0}
                                                     className={isChild ? 'mt-2' : ''}>
                                                    <Typography.Text strong className={'d-block'}>{item.description}</Typography.Text>
                                                    {renderAnswer(item)}
                                                </Col>
                                            </Row>
                                        )}
                                        {shouldShow(item) && getChildren(item.order).map((child: any) => renderItemRecursive(child, true))}
                                    </React.Fragment>
                                );
                                return (responseData.data || [])
                                    .filter((q: any) => !q.dependentQuestion)
                                    .sort((a: any, b: any) => a.order - b.order)
                                    .map((item: any) => renderItemRecursive(item, false));
                            })()}
                        </Col>
                    </Card>
                )}
            </Spin>
        </Col>
    )
}